import dynamic from 'next/dynamic';

const KycVerificationBannerDynamic = dynamic(
  async () => import('./index').then((m) => m.KycVerificationBanner),
  {
    ssr: false,
    loading: () => null,
  }
);

export { KycVerificationBannerDynamic };
